import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MenuDTO } from 'src/app/shared/model/dto/MenuDTO';
import { ensureSwiperRegistered } from 'src/app/shared/utils/lazy-swiper';
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeUrl, SafeStyle } from '@angular/platform-browser';
import { ModalController, AlertController, LoadingController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { User } from 'src/app/shared/model/User';
import { UtilsService } from 'src/app/core/services/utils.service';
import { NavService } from 'src/app/core/services/nav.service';
import { DebugModeService } from 'src/app/core/services/debugMode.service';
import { KeenTrackingService } from 'src/app/core/services/keenTracking.service';
import { ModalPage } from '../modal/modal.page';
import { LoginPage } from '../login/login.page';
import { SocialAuth } from '../../core/services/SocialAuth.service'
import { LogoutDialogPage } from '../shared/logout-dialog/logout-dialog.page';
import { LocalStorageService } from "src/app/core/services/localStorage.service";
import { TableService } from 'src/app/core';

declare let FB: any

@Component({
	selector: 'app-header',
	templateUrl: './header.page.html',
	styleUrls: ['./header.page.scss'],
})

export class HeaderPage implements OnInit {

	@Input() restaurant: MenuDTO;
	user: User
	isLoggedIn: boolean
	loginMode;
	debugMode: number;
	hasMisingPayment: boolean

	isNewHomePedirDelivery = false;
	
	get isRestaurantBlocked(): boolean {
		return !!this.restaurant?.info?.blocked;
	}

	hasImages: boolean;
	hasNoImages: boolean;

	imgURL = environment.imgURL;
	imgCover: SafeUrl | null = null;
	/** Para o layout legado: background-image da capa (SafeStyle). */
	imgCoverStyle: SafeStyle | null = null;
	imgProfile;
	highlightImages;

	public currentTable;

	constructor(private sanitizer: DomSanitizer,
				private navService: NavService,
				private router: Router,
				private authService: AuthenticationService,
				private debugModeService: DebugModeService,
				private alertController: AlertController,
				private loadingController: LoadingController,
				private utils: UtilsService,
				private modalController: ModalController,
				private keen: KeenTrackingService,
				private socialAuthService: SocialAuth,
				private localStorageService: LocalStorageService,
				private tableService: TableService,
	) { }


	ngOnInit() {
		this.isNewHomePedirDelivery = !!this.restaurant?.info?.modules?.new_home_pedir_delivery;
		this.hasImages = !!(this.restaurant.info.profile_pic || this.restaurant.info.cover_pic);
		this.hasNoImages = !this.hasImages;
		this.imgCover = this.restaurant.info.cover_pic
			? this.sanitizer.bypassSecurityTrustUrl(`${this.imgURL}/covers/${this.restaurant.info.cover_pic}.jpg`)
			: null;
		this.imgCoverStyle = this.restaurant.info.cover_pic
			? this.sanitizer.bypassSecurityTrustStyle(`url(${this.imgURL}/covers/${this.restaurant.info.cover_pic}.jpg)`)
			: null;
		this.imgProfile = this.restaurant.info.profile_pic
			? this.sanitizer.bypassSecurityTrustUrl(`${this.imgURL}/profiles/${this.restaurant.info.profile_pic}.jpg`)
			: null;
		this.highlightImages = this.restaurant.info.highlightImages;
		// Só carrega o Swiper se HOUVER imagens (highlightImages costuma vir []
		// — e if([]) é truthy em JS, o que baixava o chunk de 183KB à toa).
		if (this.highlightImages?.length) { ensureSwiperRegistered(); }
		this.isLoggedIn = this.authService.isLoggedIn();
		this.loginMode = this.authService.getLoginMode();
		this.authService.changeStatus.subscribe(response => {
			this.isLoggedIn = response;
		});
		this.authService.changeLoginMode.subscribe(response => {
			this.loginMode = response;
		});

		this.debugMode = this.debugModeService.getMode();
		this.hasMisingPayment = this.checkMissingMercadopagoPayments();

        this.currentTable = this.tableService.currentTable;
	}

	async goToLogin() {
		const loginModal = await this.modalController.create({
			component: ModalPage,
			componentProps: {
				"root": LoginPage
			}
		})

		loginModal.present();
	}

	async confirmLogout() {
		if (this.isNewHomePedirDelivery) {
			const modal = await this.modalController.create({
				component: LogoutDialogPage,
				cssClass: 'modal-logout-dialog',
				backdropDismiss: true,
			});
			modal.onDidDismiss().then(({ data }) => {
				if (data?.confirmed) this.loadingLogout(this.loginMode);
			});
			return modal.present();
		}

		const alert = await this.alertController.create({
			message: 'Tem certeza que deseja sair?',
			buttons: [
				{
					text: 'NÃO',
				},
				{
					text: 'SIM',
					handler: () => {
						this.loadingLogout(this.loginMode);
					}
				}
			]
		});
		await alert.present();
	}

	async loadingLogout(mode: string) {
		const loading = await this.loadingController.create({
			message: 'Saindo...'
		});
		await loading.present();

		if (mode == 'google'){
			await this.socialAuthService.logoutWithGoogle();
		}
		
		if (this.authService.logout()) {
			this.navService.push(`/`);
			await loading.dismiss();
		}

		this.keen.setEventBase().finally(() => {
			this.keen.event('logout');
		})
	}

	timeConvert(minutes) {
		return this.utils.timeConvert(minutes);
	}

	openReviews() {
		this.navService.push('/reviews');
	}

	openPayments() {
		this.navService.push('/payments', { restaurant: this.restaurant.info });
	}

	openHours() {
		const params: any = { hours: this.restaurant.hours };

		if (this.isNewHomePedirDelivery) {
			params.restaurant = this.restaurant.info;
		}

		this.navService.push('/hours', params);
	}

	openInfo() {
		if (this.isNewHomePedirDelivery) {
			return this.navService.push('/info-tabs', { restaurant: this.restaurant.info, hours: this.restaurant.hours });
		}
		this.navService.push('/info', { restaurant: this.restaurant.info });
	}

	checkMissingMercadopagoPayments() {
		let keys = Object.keys(this.localStorageService),
        index = 0, key;

		for (; key = keys[index]; index++) {
			if (key.indexOf('external_reference_') === 0) {
				return true
			}
		}
	}

	getTodayHoursDisplay(): string {
		if (!this.restaurant?.hours?.hours) return '';
		const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
		const today = days[new Date().getDay()];
		const slots: any[] = this.restaurant.hours.hours[today];
		if (!slots?.length) return '';

		const fmt = (t: string) => (t && t.length >= 5) ? t.substring(0, 5) : t;
		const toMinutes = (t: string) => {
			const [h, m] = t.split(':').map(Number);
			return h * 60 + m;
		};

		const now = new Date();
		const nowMinutes = now.getHours() * 60 + now.getMinutes();

		const openSlots = slots.filter((s: any) => !s.isClosed && s.firstTime && s.secondTime);
		if (!openSlots.length) return '';

		const current = openSlots.find((s: any) => {
			const start = toMinutes(s.firstTime);
			const end = toMinutes(s.secondTime);
			return nowMinutes >= start && nowMinutes <= end;
		});

		if (current) {
			return `${fmt(current.firstTime)} - ${fmt(current.secondTime)}`;
		}

		const next = openSlots
			.filter((s: any) => toMinutes(s.firstTime) > nowMinutes)
			.sort((a: any, b: any) => toMinutes(a.firstTime) - toMinutes(b.firstTime))[0];

		if (next) {
			return `${fmt(next.firstTime)} - ${fmt(next.secondTime)}`;
		}

		return '';
	}

}
